import { motion } from 'framer-motion';
import QuestionCard from './QuestionCard';

const QuestionsList = ({ questions, projectSlug, isProjectOwner, currentUser }) => {
  // Separate pinned and regular questions
  const pinnedQuestions = questions.filter(q => q.is_pinned);
  const regularQuestions = questions.filter(q => !q.is_pinned);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="space-y-4"
    >
      {/* Pinned Questions Section */}
      {pinnedQuestions.length > 0 && (
        <div className="space-y-4">
          <div className="flex items-center gap-2 text-sm sm:text-base font-medium text-neutral-700 px-1">
            <span className="w-4 h-4 text-primary-teal">📌</span>
            <span>Pinned Questions</span>
          </div>
          {pinnedQuestions.map((question) => (
            <motion.div key={question.id} variants={itemVariants}>
              <QuestionCard
                question={question}
                projectSlug={projectSlug}
                isProjectOwner={isProjectOwner}
                currentUser={currentUser}
                isPinned={true}
              />
            </motion.div>
          ))}
        </div>
      )}

      {/* Regular Questions Section */}
      {regularQuestions.length > 0 && (
        <div className="space-y-4">
          {pinnedQuestions.length > 0 && (
            <div className="flex items-center gap-2 text-sm sm:text-base font-medium text-neutral-700 pt-2 px-1">
              <span>All Questions ({regularQuestions.length})</span>
            </div>
          )}
          {regularQuestions.map((question) => (
            <motion.div key={question.id} variants={itemVariants}>
              <QuestionCard
                question={question}
                projectSlug={projectSlug}
                isProjectOwner={isProjectOwner}
                currentUser={currentUser}
                isPinned={false}
              />
            </motion.div>
          ))}
        </div>
      )}
    </motion.div>
  );
};

export default QuestionsList;
